import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Target, Compass, Sparkles, TrendingUp } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function TransformationSection() {
  const benefits = [{
    icon: Shield,
    title: 'Más seguridad',
    desc: 'Llegás a cada práctica sabiendo qué evaluar y por qué.',
    highlight: 'Sin dudas. Sin improvisación.'
  }, {
    icon: Target,
    title: 'Más criterio clínico',
    desc: 'Pasás de aplicar tests al azar a razonar como un',
    highlight: 'kinesiólogo formado de verdad.'
  }, {
    icon: Compass,
    title: 'Menos improvisación',
    desc: 'Cada paso de la evaluación está documentado.',
    highlight: 'Seguís el protocolo, no la intuición.'
  }, {
    icon: Sparkles,
    title: 'Más claridad',
    desc: 'Anamnesis, hipótesis, tests, diagnóstico funcional:',
    highlight: 'todo conectado. Todo ordenado.'
  }, {
    icon: TrendingUp,
    title: 'Más confianza en práctica',
    desc: 'Tu tutor lo nota. Tus compañeros lo notan.',
    highlight: 'Vos lo sentís desde el primer día.'
  }];
  return <AnimatedSection className="bg-navy-950 relative overflow-hidden" data-id="element-286">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-287"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12" data-id="element-289">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-4 sm:mb-5" data-id="element-290">
            La transformación
          </div>
          <h2 className="font-heading font-extrabold text-2xl sm:text-4xl md:text-5xl text-white leading-[1.05] mb-3 sm:mb-5" data-id="element-291">
            Lo que cambia cuando tenés{' '}
            <span className="font-editorial italic text-gold font-medium" data-id="element-292">
              un sistema clínico claro.
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-400 leading-relaxed px-2" data-id="element-293">
            No se trata de saber más teoría. Se trata de tener{' '}
            <span className="font-editorial italic text-gold/90" data-id="element-294">un orden</span>
            . Una estructura que te acompañe desde la anamnesis hasta el plan de
            tratamiento.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-5" data-id="element-295">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="group bg-gradient-to-b from-navy-900 to-navy-900/50 border border-gold/10 hover:border-gold/40 rounded-2xl p-4 sm:p-5 md:p-6 transition-all" data-id="element-296">
              <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-gold/20 transition-colors" data-id="element-297">
                <benefit.icon size={18} className="text-gold sm:w-5 sm:h-5" data-id="element-298" />
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-white mb-2 leading-tight" data-id="element-299">
                {benefit.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-400 leading-relaxed" data-id="element-300">
                {benefit.desc}{' '}
                <span className="font-editorial italic text-gold/90" data-id="element-301">
                  {benefit.highlight}
                </span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </AnimatedSection>;
}